import { render, staticRenderFns } from "./DownloadTasks.vue?vue&type=template&id=f1c344c8&scoped=true"
import script from "./DownloadTasks.vue?vue&type=script&lang=js"
export * from "./DownloadTasks.vue?vue&type=script&lang=js"
import style0 from "./DownloadTasks.vue?vue&type=style&index=0&id=f1c344c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c344c8",
  null
  
)

export default component.exports